import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["uiProps", "overrideProps", "showHidden"];
function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);
  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);
    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { useContext } from "react";
import PropTypes from "prop-types";
import { ComponentMapContext } from "../componentMap/ComponentMapProvider";
import { renderContentFromMetadataInternal } from "../render/renderMetadataHelper";
var metadataContentPropTypes = {
  uiProps: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.any), PropTypes.array]).isRequired,
  overrideProps: PropTypes.objectOf(PropTypes.any),
  resolveValidation: PropTypes.func,
  resolveFormValidation: PropTypes.func,
  resolveDataProps: PropTypes.func,
  resolveValue: PropTypes.func,
  resolveComponentMap: PropTypes.objectOf(PropTypes.any),
  resolveClassNameMap: PropTypes.objectOf(PropTypes.any),
  resolveCallbackMap: PropTypes.objectOf(PropTypes.any),
  showHidden: PropTypes.bool
};
export var MetadataContent = function MetadataContent(_ref) {
  var uiProps = _ref.uiProps,
    overrideProps = _ref.overrideProps,
    showHidden = _ref.showHidden,
    resolvers = _objectWithoutProperties(_ref, _excluded),
    resolveComponent = useContext(ComponentMapContext),
    resolversWithOverrides = _objectSpread(_objectSpread({}, resolvers), {}, {
      resolveComponent: resolveComponent
    });
  return renderContentFromMetadataInternal(uiProps, overrideProps, resolversWithOverrides, showHidden);
};
MetadataContent.propTypes = metadataContentPropTypes, MetadataContent.defaultProps = {
  showHidden: !1
};